import getters from "./getters";
import state from "./state";
import Vue from "vue";

import { get } from "../axios";
import { Toast } from "vant";
const mutations = {
  PUSH_INCLUDE(state, String) {
    state.include.push(String);
  },
  DELETE_INCLUDE(state, String) {
    if (String === "delete") {
      state.include = [];
    } else {
      const i = state.include.indexOf(String);
      if (i > -1) {
        state.include.splice(i, 1);
      }
    }
  },
  PUSH_AXIOS_PING(state, obj) {
    state.axiosPing.push(obj);
  },
  REMOVE_AXIOS_PING(state, Index) {
    state.axiosPing.splice(Index, 1);
  },
  LOADING_SHOW(state, Boolean) {
    state.loading = Boolean;
  },
  SET_BACK_FLAG(state, Boolean) {
    state.backFlag = Boolean;
  },
  SET_LANGUAGE(state, String) {
    state.language = String;
  },
  SET_TOKEN(state, String) {
    state.token = String;
  },
  GET_USER_INFO(state, obj) {
    if (typeof obj === "string" && obj == "delete") {
      state.userInfo = {};
    } else if (typeof obj === "object") {
      // state.userInfo = obj;
      if (JSON.stringify(state.userInfo) == "{}") {
        state.userInfo = obj;
      } else {
        for (var key in obj) {
          state.userInfo[key] = obj[key];
        }
      }
    }
    console.log("==== 用户信息 ====", state.userInfo);
  },
  GET_PLATFORM_INFO(state, obj) {
    state.platformInfo = obj;
    console.log("==== 平台信息 ====", obj);
  },
  SET_SHOPCART_DATA(state, object) {
    if (typeof object === "string" && object == "delete") {
      state.shopCartData = [];
    } else if (typeof object === "object") {
      let num = true;
      if (state.shopCartData.length) {
        // let count = 0;
        for (let i = 0; i < state.shopCartData.length; i++) {
          if (
            object.count == 0 &&
            state.shopCartData[i].product_id == object.product_id
          ) {
            Vue.delete(state.shopCartData, i);
            break;
          }
          if (state.shopCartData[i].product_id == object.product_id) {
            num = false;
            Vue.set(state.shopCartData[i], "count", object.count);
          }
        }
      }
      if (num && object.count != 0) {
        state.shopCartData.push(object);
      }
    }
    console.log("==== 购物车 ====", state.shopCartData);
  },
  SET_AGAIN_ORDER(state, object) {
    if (typeof object === "string" && object == "delete") {
      state.againOrder = [];
    } else if (typeof object === "object") {
      state.againOrder = object;
      console.log("==== 再来一单 ====", state.againOrder);
    }
  },
  SET_LOCATION(state, object) {
    if (typeof object === "string" && object == "delete") {
      state.location = {};
    } else if (typeof object === "object") {
      let obj = {};
      obj.latitude = object[0].geometry.location.lat;
      obj.longitude = object[0].geometry.location.lng;
      obj.place_id = object[0].place_id;
      let city1, city2, city3;
      let list = object[0].address_components;
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < list[i].types.length; j++) {
          if (list[i].types[j] == "locality") {
            city1 = list[i].long_name;
          }
          if (list[i].types[j] == "administrative_area_level_1") {
            city2 = list[i].long_name;
          }
          if (list[i].types[j] == "country") {
            city3 = list[i].long_name;
          }
        }
      }
      obj.city = city1 ? city1 : city2 ? city2 : city3;
      obj.address = object[0].formatted_address;
      state.location = obj;
      localStorage.setItem("location", JSON.stringify(obj));
    } else {
      let obj = {};
      // 获取位置
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function(position) {
            // 获取地理位置成功
            console.log("经度:" + position.coords.longitude);
            console.log("纬度:" + position.coords.latitude);
            console.log("准确度:" + position.coords.accuracy);
            console.log("海拔:" + position.coords.altitude);
            console.log("海拔准确度:" + position.coords.altitudeAcuracy);
            console.log("行进方向:" + position.coords.heading);
            console.log("地面速度:" + position.coords.speed);
            console.log("请求的时间:" + new Date(position.timestamp));
            let params = {};
            // params.address = "深圳";
            params.language = state.language == "en" ? "en_US" : "zh_CN";
            params.latlng =
              position.coords.latitude + "," + position.coords.longitude;
            params.key = "AIzaSyCP8wu3wUtUEeHtar4qE7ftbWGRdcYKn80";
            console.log("getLocation.params", params);
            get("https://maps.googleapis.com/maps/api/geocode/json", params)
              .then(res => {
                console.log("getLocation.res", res);
                if (res.status == "OK") {
                  obj.latitude = position.coords.latitude;
                  obj.longitude = position.coords.longitude;
                  obj.place_id = res.results[0].place_id;
                  let city1, city2, city3;
                  let list = res.results[0].address_components;
                  for (let i = 0; i < list.length; i++) {
                    for (let j = 0; j < list[i].types.length; j++) {
                      if (list[i].types[j] == "locality") {
                        city1 = list[i].long_name;
                      }
                      if (list[i].types[j] == "administrative_area_level_1") {
                        city2 = list[i].long_name;
                      }
                      if (list[i].types[j] == "country") {
                        city3 = list[i].long_name;
                      }
                    }
                  }
                  obj.city = city1 ? city1 : city2 ? city2 : city3;
                  obj.address = res.results[0].formatted_address;
                  state.location = obj;
                  localStorage.setItem("location", JSON.stringify(obj));
                } else {
                  Toast("定位失败");
                }
              })
              .catch(error => {
                console.log("getLocation.error", error);
                Toast("定位失败catch");
                // obj.latitude = 22.544986;
                // obj.longitude = 114.064794;
                // obj.place_id = "ChIJy4vTvhP0AzQRIqGmJ_uVz-Y";
                // obj.city = "深圳市";
                // obj.address = "error";
                // state.location = obj;
                // localStorage.setItem("location", JSON.stringify(obj));
                // console.log("==== location.error ====", obj);
              });
          },
          function(error) {
            // 获取地理位置失败
            console.log(error);
            console.log("Error code " + error.code + ". " + error.message);
            switch (error.code) {
              case error.PERMISSION_DENIED:
                Toast("定位失败,用户拒绝请求地理定位");
                break;
              case error.POSITION_UNAVAILABLE:
                Toast("定位失败,位置信息是不可用");
                break;
              case error.TIMEOUT:
                Toast("定位失败,请求获取用户位置超时");
                break;
              case error.UNKNOWN_ERROR:
                Toast("定位失败,定位系统失效");
                break;
            }
            console.log("locationError", error);
            Toast("定位失败error");
            // obj.latitude = 22.544986;
            // obj.longitude = 114.064794;
            // obj.place_id = "ChIJy4vTvhP0AzQRIqGmJ_uVz-Y";
            // obj.city = "深圳市";
            // obj.address = "error";
            // state.location = obj;
            // localStorage.setItem("location", JSON.stringify(obj));
            // console.log("==== location.error ====", obj);
          },
          {
            // 指示浏览器获取高精度的位置，默认为false
            enableHighAccuracy: true,
            // 指定获取地理位置的超时时间，默认不限时，单位为毫秒
            timeout: 5000,
            // 最长有效期，在重复获取地理位置时，此参数指定多久再次获取位置。
            maximumAge: 3000
          }
        );
      } else {
        Toast("Your browser does not support Geolocation!");
      }
    }
    console.log("==== location ====", state.location);
  }
};
export default {
  state,
  mutations,
  getters
};
